import {Grid, Typography} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {useEffect, useState} from "react";
import {
    DetailsCardContainer,
    DetailsColumn,
    DetailsContainer,
    DetailsLabel,
    DetailsRow,
    DetailsText,
    TopBarContainedBrandButton,
    TopBarContainedCancelButton,
    TopBarContainer,
} from "../../../constants/component.constants";
import {ResponsiveRow} from "../../../constants/layout.constants";
import MeterChargesCard from "../../cards/meterChargesCard";
import NoteLogsCard from "../../cards/noteLogsCard";
import {DocumentStore} from "../../documentStore";
import TransactionHistory from "../../transactionHistory";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {printMeterBilling, printMeterBillingStatement,} from "../../../services/print.service";
import {formatCurrency, formatDate} from "../../../util/util";
import {getMetersByMeterBilling} from "../../../services/meterbilling.service";
import dayjs from "dayjs";

export default function ViewMeterBilling(props) {
    /**
     *
     * REQUIRED PROPS
     *
     * selectedMeterBilling
     * handleClose
     * openCreditModal
     * openChargeModel
     * voiditem
     * handleVoidClick
     */
    const [selectedMeterBilling, setSelectedMeterBilling] = useState(null);
    const [statementYear, setStatementYear] = useState(new Date());
    const [activeMeters, setActiveMeters] = useState([]);

    useEffect(() => {
        if (props.selectedMeterBilling) {
            setSelectedMeterBilling(props.selectedMeterBilling);
            // Fetch active meters for this billing
            if (props.selectedMeterBilling.id) {
                getMetersByMeterBilling(props.selectedMeterBilling.id)
                    .then((meters) => {
                        setActiveMeters(meters || []);
                    })
                    .catch((error) => {
                        console.error("Error fetching meters:", error);
                        setActiveMeters([]);
                    });
            }
        } else {
            setSelectedMeterBilling(null);
            setActiveMeters([]);
        }
    }, [props.selectedMeterBilling]);

    function handleStatementYearChange(value) {
        let date = new Date(value);
        setStatementYear(date);
    }

    function handlePrintMeterBillingStatement() {
        printMeterBillingStatement(
            selectedMeterBilling.id,
            statementYear.getFullYear()
        );
    }

    function handlePrintMeterBilling() {
        printMeterBilling(selectedMeterBilling.id);
    }

    return (
        <>
            <TopBarContainer
                container
                sx={{
                    width: {xs: "100%", lg: "80%"},
                    boxShadow: "4px 4px 12px #aaa",
                    flexWrap: {xs: "wrap", lg: "nowrap"},
                }}
            >
                <Grid
                    item
                    sx={{width: {xs: "100%", lg: "50%"}, textAlign: "start"}}
                >
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="en-gb"
                    >
                        <DatePicker
                            sx={{width: "90%"}}
                            id={"statementYear"}
                            value={dayjs(statementYear)}
                            disableFuture={true}
                            disablePast={false}
                            openTo="year"
                            views={["year"]}
                            isrequired={true}
                            onChange={(newDate) => handleStatementYearChange(newDate)}
                            
                        />
                    </LocalizationProvider>
                </Grid>
                <ResponsiveRow
                    item
                    sx={{
                        flexWrap: {xs: "wrap", lg: "nowrap"},
                        justifyContent: {xs: "center", lg: "flex-end"},
                        padding: 0,
                    }}
                >
                    <TopBarContainedBrandButton onClick={handlePrintMeterBilling} sx={{}}>
                        Print Billing
                    </TopBarContainedBrandButton>

                    <TopBarContainedBrandButton
                        onClick={handlePrintMeterBillingStatement}
                    >
                        Print Meter Billing Statement
                    </TopBarContainedBrandButton>

                    <TopBarContainedCancelButton
                        // type="submit"
                        sx={{width: {xs: "100%", lg: "150px"}}}
                        onClick={props.handleClose}
                    >
                        Close
                    </TopBarContainedCancelButton>
                </ResponsiveRow>
            </TopBarContainer>
            <br/>

            <Grid
                container
                variant=""
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "40px",
                    textAlign: "left",
                }}
            >
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    Billing Information for{" "}
                    {props.selectedMeterBilling &&
                        props.selectedMeterBilling.contracteeName}
                </Typography>
                <br/>
                <DetailsCardContainer sx={{width: "100%", padding: 0}}>
                    <DetailsContainer
                        sx={{
                            justifyContent: "space-around",
                            // padding: 0,
                        }}
                    >
                        <DetailsColumn sx={{width: { xs: "100%", md: "33.3%"}}}>
                            <Typography
                                sx={{marginBottom: "20px", fontSize: "20px"}}
                                id="modal-modal-title"
                                variant="h5"
                                component="h4"
                            >
                                Meter Information
                            </Typography>
                            <DetailsRow>
                                <DetailsLabel> Property: </DetailsLabel>
                                <DetailsText>
                                    {props.selectedMeterBilling &&
                                        props.selectedMeterBilling.facilityName}
                                </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                                <DetailsLabel> Meters: </DetailsLabel>
                                <DetailsText>
                                    {activeMeters && activeMeters.length > 0 ? (
                                        activeMeters.map((meter) => meter.label).join(", ")
                                    ) : (
                                        <Typography variant="body2" color="text.secondary">
                                            No active meters
                                        </Typography>
                                    )}
                                </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                                <DetailsLabel> Customer Name: </DetailsLabel>
                                <DetailsText>
                                    {props.selectedMeterBilling &&
                                        props.selectedMeterBilling.contracteeName}
                                </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                                <DetailsLabel> Balance: </DetailsLabel>
                                <DetailsText>
                                    {formatCurrency(
                                        props.selectedMeterBilling?.meterBillingBalance
                                    )}
                                </DetailsText>
                            </DetailsRow>
                        </DetailsColumn>
                        <DetailsColumn sx={{width: { xs: "100%", md: "33.3%"}}}>
                            <Typography
                                sx={{marginBottom: "20px", fontSize: "20px"}}
                                id="modal-modal-title"
                                variant="h5"
                                component="h4"
                            >
                                Status Information
                            </Typography>
                            <DetailsRow>
                                <DetailsLabel> Status: </DetailsLabel>
                                <DetailsText>
                                    {props.selectedMeterBilling &&
                                        props.selectedMeterBilling.statusCd}
                                </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                                <DetailsLabel> Effective Date: </DetailsLabel>
                                <DetailsText>
                                    {formatDate(
                                        props.selectedMeterBilling &&
                                        props.selectedMeterBilling.effectiveDate
                                    )}
                                </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                                <DetailsLabel> Expiration Date: </DetailsLabel>
                                <DetailsText>
                                    {props.selectedMeterBilling &&
                                        props.selectedMeterBilling.expirationDate}
                                </DetailsText>
                            </DetailsRow>
                        </DetailsColumn>

                        <DetailsColumn sx={{width: { xs: "100%", md: "33.3%"}}}>
                            <Typography
                                sx={{marginBottom: "20px", fontSize: "20px"}}
                                id="modal-modal-title"
                                variant="h5"
                                component="h4"
                            >
                                Billing Information
                            </Typography>
                            <DetailsRow>
                                <DetailsLabel> Billing Code: </DetailsLabel>
                                <DetailsText>
                                    {props.selectedMeterBilling &&
                                        props.selectedMeterBilling.billingCode}
                                </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                                <DetailsLabel> Billing Frequency: </DetailsLabel>
                                <DetailsText>
                                    {props.selectedMeterBilling &&
                                        props.selectedMeterBilling.billingFrequency}
                                </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                                <DetailsLabel> Billing Day/Date: </DetailsLabel>
                                <DetailsText>
                                    {props.selectedMeterBilling &&
                                        (props.selectedMeterBilling.billingDay ||
                                            props.selectedMeterBilling.billingDate)}
                                </DetailsText>
                            </DetailsRow>
                        </DetailsColumn>
                    </DetailsContainer>
                </DetailsCardContainer>

                <ResponsiveRow
                    sx={{
                        width: "100%",
                        height: "auto",
                        flexDirection: { xs: "column", lg: "row" },
                        flexWrap: "nowrap",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: { xs: 0, lg: "10px auto 5px auto" },
                        padding: 0,
                    }}
                >
                    <NoteLogsCard
                        notesMode={"Meter Billing"}
                        contract={props.selectedMeterBilling}
                        width="33.3%"
                        height="500px"
                        minHeight="200px"
                    />
                    <MeterChargesCard
                        notesMode={"Meter Billing"}
                        contract={props.selectedMeterBilling}
                        height="500px"
                        minHeight="200px"
                    />
                    <DocumentStore
                        files={[
                            ...props.selectedMeterBilling?.imageFiles,
                            ...props.selectedMeterBilling?.otherDocuments,
                        ]}
                        item={props.selectedMeterBilling}
                        type={"Meter Billing"}
                        height="500px"
                        maxWidth="33.3%"
                        minHeight="200px"
                    />
                </ResponsiveRow>
                <br/>

                {/* Shared Transaction History */}
                <TransactionHistory
                    transactionMode={"Meter Billing"}
                    contract={props.selectedMeterBilling}
                    handleVoidClick={props.handleVoidClick}
                    height="80vh"
                />
                <br/>
            </Grid>
            <br/>
        </>
    );
}
